import React, { useEffect, useState } from "react";
import { Users, MessageSquareQuote, Inbox, Target, TrendingUp, Handshake } from "lucide-react";
import { api } from "@/lib/api";

const Card = ({ icon: Icon, label, value, testId }) => (
  <div className="border-2 border-[#0A0A0A] p-6 bg-[#FAFAF7]" data-testid={testId}>
    <div className="flex items-start justify-between">
      <Icon size={24} strokeWidth={1.5} className="text-[#FF5A1F]" />
      <div className="text-[10px] uppercase tracking-widest text-[#0A0A0A]/50 font-bold">Live</div>
    </div>
    <div className="mt-4 font-display text-5xl leading-none text-[#0A0A0A]">{value}</div>
    <div className="mt-2 text-xs uppercase tracking-widest text-[#0A0A0A]/60">{label}</div>
  </div>
);

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 lg:p-10" data-testid="admin-dashboard">
      <div className="mb-8">
        <div className="text-xs font-bold uppercase tracking-widest text-[#FF5A1F]">— Overview</div>
        <h1 className="font-display text-5xl uppercase text-[#0A0A0A] mt-2">Dashboard</h1>
        <p className="text-[#0A0A0A]/60 mt-2">Benvenuto nel CMS Perla Music.</p>
      </div>

      {loading ? (
        <div className="text-[#0A0A0A]/50">Caricamento…</div>
      ) : stats ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Card icon={Users} label="Artisti in roster" value={stats.artists} testId="stat-artists" />
          <Card icon={MessageSquareQuote} label="Testimonianze" value={stats.testimonials} testId="stat-testimonials" />
          <Card icon={Handshake} label="Team + Partner" value={(stats.team || 0) + (stats.partners || 0)} testId="stat-team" />
          <Card icon={Inbox} label="Lead totali" value={stats.leads_total} testId="stat-leads-total" />
          <Card icon={Target} label="Lead Landing 1" value={stats.leads_landing1} testId="stat-leads-landing1" />
          <Card icon={Target} label="Lead Landing 2" value={stats.leads_landing2} testId="stat-leads-landing2" />
          <Card icon={TrendingUp} label="Lead Contatti" value={stats.leads_contact} testId="stat-leads-contact" />
        </div>
      ) : null}

      <div className="mt-12 border-2 border-[#0A0A0A] p-6 bg-[#F2F2EC]">
        <h2 className="font-display text-2xl uppercase text-[#0A0A0A]">Cosa puoi fare qui</h2>
        <ul className="mt-4 space-y-2 text-sm text-[#0A0A0A]/70">
          <li>• Aggiungere / modificare / rimuovere <strong>artisti</strong> del roster</li>
          <li>• Gestire <strong>testimonianze</strong> (testi + video YouTube)</li>
          <li>• Modificare i <strong>testi del sito</strong> in italiano e inglese</li>
          <li>• Visualizzare ed esportare tutti i <strong>lead</strong> in arrivo</li>
        </ul>
      </div>
    </div>
  );
}
